import React from "react";

export default function SocialIcon( {data} ) {
  return(
    <li><a rel="noreferrer" target="_blank" className={'social social--' + data.icon} href={ data.url }>&nbsp;</a></li>
  )
}